import { InputText } from 'component-library/index';
import React from 'react';
import { memo } from 'react';
import { useField } from '../../../providers/ModernAcquisitionProvider/useField';
import { generateFieldErrorMessage } from '../../../utils/error-message';

export interface IMiddleInitialFieldWithProviderProps {
    fieldKey: 'middleInitial' | 'authorizedUserMiddleInitial';
    name: string;
    label?: string;
    id?: string;
    disabled?: boolean;
    onBlurCallback?: () => void;
    onFocusCallback?: () => void;
}

const MemoizedInputText = memo(InputText);

export const MiddleInitialFieldWithProvider = memo(function MiddleInitialFieldWithProvider(props: IMiddleInitialFieldWithProviderProps & React.HTMLAttributes<HTMLInputElement>, ...rest) {

    const { field, updateField } = useField(props.fieldKey);

    const formattedMiddleInitial = (value: string): string => {
        const initial = value.replace(/[^a-zA-Z]/g, '').toUpperCase();

        if (initial.length > 1) {
            return initial.substring(0, 1);
        }

        return initial;
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const formatted = formattedMiddleInitial(event.target.value);

        if (field.value !== event.target.value) {
            updateField({ ...field, state: 'neutral', value: formatted });
        } else {
            updateField({ ...field, value: formatted });
        }
    }

    const handleBlur = (): void => {
        if (field.value) {
            updateField({ ...field, state: 'success', errorType: 'None' })
        } else {
            updateField({ ...field, state: 'neutral'})
        }

        //Incase someone wants to extend blur functionality.
        props.onBlurCallback && props.onBlurCallback();
    }

    const handleFocus = (): void => {
        if (field.state === 'success') {
            updateField({ ...field, state: 'neutral' })
        }

        //Incase someone wants to extend focus functionality.
        props.onFocusCallback && props.onFocusCallback();
    }

    return (
        <MemoizedInputText
            name={props.name}
            label={props.label}
            id={props.id}
            value={field.value}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
            errorMessage={generateFieldErrorMessage(props.name)}
            state={field.state}
            maxLength={1}
            disabled={props.disabled}
            containerId='middleInitial-field-container'
            {...rest}
        />

    )

});

export default MiddleInitialFieldWithProvider;